import getCalendarSharingInitialState from '../selectors/getCalendarSharingInitialState';
import getStore from '../store/store';
import { mutatorAction } from 'satcheljs';

const assign = require('object-assign');

/**
 * Mutator to clear current state of shared calendars option store
 */
export default mutatorAction('discardSharedCalendarOption', function discardSharedCalendarOption() {
    let store = getStore();
    let initialState = getCalendarSharingInitialState();
    store.currentState = assign({}, initialState);
});
